import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchAvailablePermissions = async (): Promise<string[]> => {
	const response = await cmsClient.get<string[]>(
		"/roles/available-permissions/"
	);
	return response.data;
};

const useAvailablePermissions = () => {
	return useQuery(["available-permissions"], fetchAvailablePermissions, {
		staleTime: 5 * 60 * 1000
	});
};

export default useAvailablePermissions;
